(function () {
  let updateScheduled = false;

  function getRoConnect() {
    return document.querySelector('.rc-easybox.rc-delivery-selector');
  }

  function isCartEmpty() {
    return !!document.querySelector('.cart-page.cart-page--empty');
  }

  function hasSelectedLocker() {
    const roConnect = getRoConnect();

    if (!roConnect) return false;

    const lockerAddress = roConnect.querySelector(
      '.rc-delivery-selector__locker-address'
    );

    return !!(
      lockerAddress &&
      lockerAddress.textContent.trim().length > 0
    );
  }

  function getWarningMessage() {
    const cartCtas = document.querySelector('.cart__ctas');
    const checkoutButton = document.querySelector('#checkout');

    if (!cartCtas || !checkoutButton) return null;

    let warningMessage = cartCtas.querySelector(
      '.no5-locker-required-message'
    );

    if (!warningMessage) {
      warningMessage = document.createElement('div');
      warningMessage.className = 'no5-locker-required-message';
      warningMessage.setAttribute('role', 'alert');
      warningMessage.textContent =
        'Selectează un EasyBox pentru a continua.';
      warningMessage.hidden = true;

      cartCtas.insertBefore(warningMessage, checkoutButton);
    }

    return warningMessage;
  }

  function updateRoConnect() {
    const roConnect = getRoConnect();

    if (!roConnect) return;

    const appBlock = roConnect.closest('.shopify-app-block');

    /* Dacă coșul este gol, ascundem complet RoConnect */
    if (isCartEmpty()) {
      if (appBlock) {
        appBlock.style.display = 'none';
      }

      return;
    }

    /* Dacă există produse, afișăm blocul */
    if (appBlock) {
      appBlock.style.display = '';
    }

    const cartCtas = document.querySelector('.cart__ctas');
    const checkoutButton = document.querySelector('#checkout');

    if (!cartCtas || !checkoutButton) return;

    /* Livrare Locker -> Alege EasyBox */
    const lockerLabel = roConnect.querySelector(
      '.rc-delivery-selector__option[data-rc-option="easybox"] .rc-delivery-selector__label'
    );

    if (
      lockerLabel &&
      lockerLabel.textContent.trim() !== 'Alege EasyBox'
    ) {
      lockerLabel.textContent = 'Alege EasyBox';
    }

    /* Alege / Schimbă */
    const changeButton = roConnect.querySelector(
      '.rc-delivery-selector__change-btn'
    );

    const hasLocker = hasSelectedLocker();

    if (changeButton) {
      const desiredText = hasLocker ? 'Schimbă' : 'Alege';

      if (changeButton.textContent.trim() !== desiredText) {
        changeButton.textContent = desiredText;
      }
    }

    /* Mutăm RoConnect deasupra butonului de checkout */
    if (appBlock) {
      appBlock.classList.add('no5-roconnect-checkout');

      if (appBlock.parentElement !== cartCtas) {
        cartCtas.insertBefore(appBlock, checkoutButton);
      }
    }

    /* Creăm mesajul de avertizare, dar îl ținem ascuns */
    const warningMessage = getWarningMessage();

    if (hasLocker && warningMessage) {
      warningMessage.hidden = true;
    }
  }

  function showLockerWarning() {
    const warningMessage = getWarningMessage();

    if (warningMessage) {
      warningMessage.hidden = false;
    }
  }

  function scheduleUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;

    requestAnimationFrame(function () {
      updateScheduled = false;
      updateRoConnect();
    });
  }

  function initRoConnect() {
    updateRoConnect();

    /* Interceptăm click-ul pe Finalizează comanda */
    document.addEventListener(
      'click',
      function (event) {
        const checkoutButton = event.target.closest('#checkout');

        if (!checkoutButton) return;

        if (!hasSelectedLocker()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          showLockerWarning();

          return false;
        }

        const warningMessage = getWarningMessage();

        if (warningMessage) {
          warningMessage.hidden = true;
        }
      },
      true
    );

    /* Protecție suplimentară la submit */
    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;

        if (
          form &&
          form.id === 'cart-form' &&
          !hasSelectedLocker()
        ) {
          event.preventDefault();
          event.stopPropagation();

          showLockerWarning();
        }
      },
      true
    );

    /* Urmărim modificările din coș și RoConnect */
    const observer = new MutationObserver(function () {
      scheduleUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initRoConnect
    );
  } else {
    initRoConnect();
  }
})();